<template lang="">
  <a
    v-if="tag === 'a'"
    :href="to"
    :target="target"
    class="link-underline link-underline-opacity-0"
  >
    <slot></slot>
  </a>
  <NuxtLink
    v-else
    :to="to"
    class="link-underline link-underline-opacity-0"
    no-prefetch
  >
    <slot></slot>
  </NuxtLink>
</template>
<script lang="ts">
export default {
  props: {
    to: {
      type: [String, Object],
      default: "/",
    },
    target: {
      type: String,
      default: "_self",
    },
  },
  computed: {
    external() {
      if (
        typeof this.to === "string" &&
        (this.to.startsWith("http:") ||
          this.to.startsWith("https:") ||
          this.to.startsWith("mailto:") ||
          this.to.startsWith("tel:") ||
          this.to.startsWith("ftp:"))
      ) {
        return true;
      }
      return false;
    },
    tag() {
      return this.external ? "a" : "NuxtLink";
    },
    gotoAttibute() {
      return this.external ? "href" : "to";
    },
    goto() {
      return this.to;
    },
  },
};
</script>
<style scoped lang="sass"></style>
